const DEV_API_PORT = 3000;
const LOCAL_DEV_API_BASE_PATHS = new Set([
  "http://localhost:3000",
  "http://127.0.0.1:3000",
]);

function getApiBasePath(): string {
  const configured = import.meta.env.VITE_API_BASE_PATH as string | undefined;

  if (
    import.meta.env.DEV &&
    typeof window !== "undefined" &&
    (!configured || LOCAL_DEV_API_BASE_PATHS.has(configured))
  ) {
    return `${window.location.protocol}//${window.location.hostname}:${DEV_API_PORT}`;
  }

  return configured ?? `http://localhost:${DEV_API_PORT}`;
}

const BASE_PATH = getApiBasePath();
const INVALID_ID = -1;

export { BASE_PATH, INVALID_ID };
